<template>
  <!-- banner topo-->
  <div v-if="bannerTopo != ''" class="slider-area">
    <div class="slider-height2 slider-bg2 d-flex align-items-center">
      <div class="container">
        <div class="row align-items-center">
          <div class="offset-xl-1 col-xl-5 col-lg-5 col-md-5">
            <div class="hero-caption hero-caption2">
              <h2>{{ bannerTopo[0].itiNome }}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- END Banner -->

  <!-- sobre-->
  <section class="project-us section-padding">
    <div class="container">
      <div v-if="textosSobre != ''" class="row sobre-alinhar">
        <!-- titulo central -->
        <div class="col-12">
          <div class="section-tittle text-center mb-60">
            <h2>{{ textosSobre[0].itiNome }}</h2>
          </div>
        </div>
        
        <div class="row txt-vert">
          <!-- textos -->
          <div class=" col-md-6">
            <div class="section-tittle">
              <p v-html="textosSobre[0].itiResumo1"></p>
            </div>
          </div>
          <!-- imagem -->
          <div class="col-md-6">
            <div>
                <img :src="$imgURL + textosSobre[0].insInstitucionalImagens[0].itgUrlImagem" class="img-sobre img-cant-red img-celular">
              </div>
          </div>
        </div>
      </div>
      
    </div>
  </section>
  <!-- END textos sobre -->

  <!-- missão, visão e valores -->
  <div v-if="missaoVisao !=''" class="untree_co-section" style="background-color: antiquewhite;">
    <div class="container">
      <div class="row">
        <!-- col-lg-4 missao -->
        <div class="col-md-6 col-lg-4 col-xl-4" v-for="item in missaoVisao" :key="item.itiId" style="padding-top: 20px;">
          <div class="service h-100">
            <h3 class="text-center">{{item.itiNome }}</h3>
            <p v-html="item.itiResumo1"></p>
          </div>
        </div> <!-- col-lg-4 -->
      </div> <!-- /.row -->
    </div> <!-- /.container -->
  </div> 
  <!-- END missão, visão e valores -->

  <!-- call to action -->
  <PageCallAction></PageCallAction>
  <!-- END call to action -->

</template>

<script>

import { useHead } from '@vueuse/head'
import axios from 'axios'
import PageCallAction from '@/components/PageCallAction.vue';

export default {
  name: 'SobreView',
  components: {
    PageCallAction,
  },

  data: () => ({
    bannerTopo: [],
    textosSobre: [],
    sanfona: [],
    missaoVisao: [],
    activeIndex: null,
    
  }),

  methods: {
    carregaMetas(texto, titulo) {
      useHead({
        title: 'FiançAqui Garantidora - Sobre' + titulo,
        meta: [
          { name: "description", content: texto },
          { name: "author", content: "Avance Digital" },
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
        ],
      })
    },
    removerTagsHTML(html) {
      const element = document.createElement('div');
      element.innerHTML = html;
      return element.textContent || element.innerText || '';
    },
    toggle(index) {
      this.activeIndex = this.activeIndex === index ? null : index;
    }
  },

  created() {

    //aqui busca banner
    axios.get('/Process/InsInstitucional/institucional/11/toposobre/0/x')
      .then(response => {
        this.bannerTopo = response.data;
        this.carregaMetas(this.removerTagsHTML(this.bannerTopo[0].itiReferencia), this.bannerTopo[0].itiNome);
        //console.log('banner topo')
        //console.log(this.bannerTopo)
      })
      .catch(error => {
        console.error(error);
      });
    //aqui busca textos 
    axios.get('/Process/InsInstitucional/institucional/12/textosobre/0/x')
      .then(response => {
        this.textosSobre = response.data;
        //console.log('textosSobre')
        //console.log(this.textosSobre)
      })
      .catch(error => {
        console.error(error);
      });
    //aqui busca missão visão
    axios.get('/Process/InsInstitucional/institucional/14/itensdosobre/0/x')
      .then(response => {
        this.missaoVisao = response.data;
        //console.log('missaoVisao')
        //console.log(this.missaoVisao)
      })
      .catch(error => {
        console.error(error);
      });
    
  }
}

</script>

<style scoped>
.accordion-button {
  cursor: pointer;
  background: #f8f9fa;
  padding: 1rem;
  border: none;
  width: 100%;
  text-align: left;
  font-weight: bold;
  transition: background-color 0.2s ease;
}

.accordion-button.collapsed {
  background: #e9ecef;
}

.accordion-collapse {
  padding: 0 1rem 1rem 1rem;
}

.accordion-item {
  border: 1px solid #dee2e6;
  margin-bottom: 0.5rem;
  border-radius: 0.25rem;
}
</style>